import { apiHelper, sharedHelper } from '@/utils'
import { API } from '@/constants'

export const customerService = {
    getCustomerByEmail,
    getAllCustomers,
    getCustomer,
    updateCustomer,
    createCustomer,
    updateCustomerStatus,
    unlockCustomer,
};

const MODULE = {
    CUSTOMER: 'customers',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllCustomers(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.CUSTOMER}`, requestOptions)
}


export function updateCustomerStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.CUSTOMER}/${data.id}`, requestOptions)
}

export function getCustomer(id) {
    return apiHelper(API_URL).get(`/${MODULE.CUSTOMER}/show/${id}/uuid`)
}

export function getCustomerByEmail(email) {
    return apiHelper(API_URL).get(`/${MODULE.CUSTOMER}/show/${email}/email`)
}

export function unlockCustomer(id) {
    return apiHelper(API_URL).patch(`/${MODULE.CUSTOMER}/${id}/unlock`)
}

export function createCustomer(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'parent_email', data.parentEmail);
    sharedHelper.appendIfNotNull(formData, 'first_name', data.firstName);
    sharedHelper.appendIfNotNull(formData, 'last_name', data.lastName);
    sharedHelper.appendIfNotNull(formData, 'email', data.email);
    sharedHelper.appendIfNotNull(formData, 'phone_code', data.phoneCode);
    sharedHelper.appendIfNotNull(formData, 'phone_iso', data.phoneISO);
    sharedHelper.appendIfNotNull(formData, 'phone', data.phone);
    sharedHelper.appendIfNotNull(formData, 'birthday', data.birthday);
    sharedHelper.appendIfNotNull(formData, 'is_receive_promotion_news', data.isReceivePromotionNew);
    sharedHelper.appendIfNotNull(formData, 'from', data.from);
    sharedHelper.appendIfNotNull(formData, 'password', data.password);
    sharedHelper.appendIfNotNull(formData, 'password_confirmation', data.passwordConfirmation);
    sharedHelper.appendIfNotNull(formData, 'vehicle_uuid', data.vehicleID);

    return apiHelper(API_URL).post(`/${MODULE.CUSTOMER}/workshop`, formData)
}

export function updateCustomer(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'phone_code', data.phoneCode);
    sharedHelper.appendIfNotNull(formData, 'phone_iso', data.phoneISO);
    sharedHelper.appendIfNotNull(formData, 'phone', data.phone);
    sharedHelper.appendIfNotNull(formData, 'email', data.email);
    sharedHelper.appendIfNotNull(formData, 'birthday', data.birthday);
    // sharedHelper.appendIfNotNull(formData, 'is_receive_promotion_news', data.isReceivePromotionNew);
    // sharedHelper.appendIfNotNull(formData, 'is_share_credit', data.isShareCredit);
    // sharedHelper.appendIfNotNull(formData, 'preferred_send_promotion_type', data.preferredSendPromotionType);
    formData.append('_method', 'PUT');

    return apiHelper(API_URL).post(`/${MODULE.CUSTOMER}/${data.id}`, formData)
}